<script setup lang="ts">
/** On Board — DR: Change in Registered Office ([[Signers]]). */
import CddVarField from '../cdd/CddVarField.vue';
import AgmSigners from '../cdd/AgmSigners.vue';
import OnBoardIncludeToggle from './OnBoardIncludeToggle.vue';
import './onboardDoc.css';
</script>

<template>
  <div class="agm-doc">
    <OnBoardIncludeToggle flag="include_dr_ro" />
    <div class="doc-head">
      <div class="doc-title"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div class="doc-sub">Company Registration No. <CddVarField field-key="company_registration_no" label="Reg. No." /></div>
      <div class="doc-sub">(Incorporated in the Republic of Singapore)</div>
      <div class="doc-sub">(the &ldquo;Company&rdquo;)</div>
    </div>

    <div class="sec-title center">DIRECTORS' RESOLUTIONS IN WRITING</div>
    <div class="doc-p center">PURSUANT TO THE COMPANY'S CONSTITUTION</div>

    <div class="sec-title">CHANGE IN THE ADDRESS OF REGISTERED OFFICE</div>
    <p class="doc-p">
      RESOLVED THAT the Registered Office Address of the Company be changed to
      <CddVarField field-key="new_registered_office_address" label="New Registered Office Address" />
      with immediate effect.
    </p>

    <div class="sec-title">LODGEMENT OF RETURNS</div>
    <p class="doc-p">
      RESOLVED THAT the Company Secretaries (or their authorised representatives) be and are hereby authorised
      and instructed to lodge the requisite statutory return(s) relating thereto with the Accounting and
      Corporate Regulatory Authority for and on behalf of the Company.
    </p>

    <div class="doc-meta">Dated: <CddVarField field-key="dr_resolution_date" label="Resolution Date" /></div>
    <AgmSigners var-key="dr_ro_Signers" board-label="Directors" />
  </div>
</template>
